import { useSession } from "@outschool/ui-auth";
import { useRequiresMembershipForEnrollment } from "@outschool/ui-components-website";
import React from "react";

import FirstMonthFreeBanner from "./FirstMonthFreeBanner";

// Use this for running experiments and diverting user cohorts to different membership banners.
export default function MembershipsBannerSwitcher() {
  const { isLoggedIn } = useSession();

  const { mustPurchaseMembership } = useRequiresMembershipForEnrollment();

  // Top level user audience filters, banners will also do their own page-specific display filters.
  const firstMonthFreeUsers = React.useMemo(
    () => !isLoggedIn || mustPurchaseMembership,
    [isLoggedIn, mustPurchaseMembership]
  );

  if (firstMonthFreeUsers) {
    return <FirstMonthFreeBanner />;
  }

  return null;
}
